



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";
import moment from "moment";
import "../styles/steplearning.scss";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

import { isIOS, isIE, isEdge, isMacOs } from "mobile-device-detect";

declare var amp: any;

@Component({
  components: {
    apexchart: VueApexCharts,
  },
})
export default class PreModuleWork extends Vue {
  private tableItems: any = [];
  private tableItemsSorted = this.sortArray(this.tableItems);
  private selectedWorkItem: any = [];
  private selected: any = [];
  private savedValues: any = [];
  private display: any = [];
  private correct: any = [];
  private disable: any = [];
  private answerAns: any = [];
  private attempted = 0;
  private currentDay = "2020-04-13";
  private currentMcqIndex = 0;
  private player: any;
  private titleModal = "";
  private bodyModal = "";
  private errorMessage = "";
  private sourceLoaded = false;
  private selectedWorkObject: any = [];
  private view = 0;
  private currentWorkItem = 0;
  private source =
    "//elvideoservices-aase.streaming.media.azure.net/7bde64ac-5624-4b25-9c6b-97a24edb6208/chem1ch3lect1-new.ism/manifest";
  private isFirst = localStorage[config.dayModal];
  private auth = new AuthService();
  private service = new GeneralService();
  private lastTime = 0;
  private errorDisable = false;
  private startError = false;
  private discussions: any = [];
  private answers = ["A", "B", "C", "D"];
  private answersE = ["A", "B", "C", "D", "E"];
  private lectures: any = [];
  private worksheets: any = [];
  private tests: any = [];
  private quizzes: any = [];
  private selfTests: any = [];
  private testSubjectsData: any = [];
  private currentSubjectTest: any = 0;
  private disableTests: any = [];
  private totalQuestions: any = 0;
  private totalCorrect: any = 0;
  private subjectCorrect: any = [];
  private subjectIncorrect: any = [];
  private totalIncorrect: any = 0;
  private totalSubjects: any = [];
  private drills: any = [];
  private showResult: any = false;
  private startTime: any;
  private endTime: any;
  private timeElapsed = "";
  private testAttempted = false;
  private sheetId: any = "";
  private totalSeries = 0;
  private totalSeriesData;
  private notAttempted = 0;
  private isM = false;
  private showTestResults = false;
  private testAttemptedOnce = false;
  private displaySelected = [];
  private switcherCount = 0;
  private reviewQuestions: any = [];
  private testTimer = 0;
  private startTimer = false;
  private startTimeTimer: any = moment();
  private endTimeTimer: any = moment().add(12, "minutes");
  private isRetake = false;
  private startTimeX: any = null;
  private endTimeX: any = null;
  private isSelfAwareness = false;
  private savedAnswers: any = [];
  private selectedWorkItemAwareness: any = {};
  private displayResult = false;
  private loadingTestFirst = false;
  private srcToken: any;
  private minQuestion = 0;
  private rangeQuestion = 10;
  private actualDuration = 0;
  private allQuestions: any = [];
  private finish = false;
  private totalNotAttempted = 0;
  private firstTimeReset = true;
  private selectedType: string = '';
  private selectedName: string = '';
  private selectProgram: string | null = null;
  private stepView = 0;
  private expertTips: any = [];
  private blogs: any = [];

  private entities = [
    {fullName: "F.Sc (Engineering)", id: "03a35705-b55b-401c-a6cb-b9fcdfa82120"},
    {fullName: "F.Sc (Medical)", id: "03a35705-b55b-401c-a6cb-b9fcdfa82110"},
    {fullName: "ICS", id: "03a35705-b55b-401c-a6cb-b9fcdfa82130"},
  ]

  private stepModules = [
    {name: 'Content Bank', fullName: 'English'},
    {name: 'Mock Tests', fullName: 'Mathematics'},
    {name: 'Expert Tips', fullName: 'B.Stat'},
    {name: 'Blogs', fullName: 'ICS'},
  ]

  getImgUrl(pet, type) {
    if (pet[pet.length - 1] == ' ') {
        pet = pet.substring(0, pet.length-1);
    }
    const images = require.context('@/assets/images/icons/', false);
    try{   
        return images('./' + pet + "." + type)
    } catch{
        // return images('./error.png')
    }
  }

  private removeSelectProgram() {
    this.selectProgram = null;
    localStorage[config.selectedStepProgram] = null;
  }

  public selectModule(name) {
    this.stepView = this.stepModules.findIndex((n) => n.name == name) + 1;
  }

  public selectSubject(id, name){
    this.$store.state.selectSubject = id;
    this.$store.state.selectSubjectName = name;
    if (name === 'F.Sc (Medical)'){
      this.isM = true;
    }
    this.loadData({id, name});
  }

  public fixLink(link) {
    if (link.indexOf('embed') > -1)
      return
    
    return link.replace('/watch?v=', '/embed/')
  }

  get modalText() {
    if (this.finish) {
      return "Do you wish to finish the " + this.selectedType;
    } else if (!this.firstTimeReset) {
      return "Do you wish to reset the " + this.selectedType;
    } else {
      return "You have already attempted this " + this.selectedType + " before. Do you wish to reset the " + this.selectedType;
    }
  }

  get chartTotalOptions() {
    let series: any = [];
    for (let i = 0; i < this.testSubjectsData.length; i++) {
      series.push(this.testSubjectsData[i].courseId);
    }
    series.push("Incorrect");
    series.push("Not Attempted");

    let options = {
      labels: series,
      legend: {
        show: false,
      },
    };
    return options;
  }

  private confirmEnd() {
    this.firstTimeReset = false;
    if (this.finish) {
      this.finishTest();
    } else {
      this.retakeTest();
    }
  }

  private nextQuestion() {
    this.switcherCount++;
    if (this.selectedWorkItem.mcqs[this.currentMcqIndex + 1])
      this.currentMcqIndex++;
    else if (this.currentSubjectTest < this.testSubjectsData.length - 1) {
      this.changeSubject(this.currentSubjectTest + 1);
    } else return;
    if (this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex])
      this.selected[this.selectedWorkItem.courseId][this.currentMcqIndex] =
        this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex];
  }

  private previousQuestion() {
    this.switcherCount++;
    if (this.currentMcqIndex > 0) this.currentMcqIndex--;
    else if (this.currentSubjectTest > 0) {
      this.changeSubject(this.currentSubjectTest - 1);
      this.currentMcqIndex = this.selectedWorkItem.mcqs.length - 1;
    } else return;

    if (this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex])
      this.selected[this.selectedWorkItem.courseId][this.currentMcqIndex] =
        this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex];
  }

  private lastQuestion() {
    this.switcherCount++;

    this.changeSubject(this.testSubjectsData.length - 1);
    this.currentMcqIndex = this.selectedWorkItem.mcqs.length - 1;

    if (this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex])
      this.selected[this.selectedWorkItem.courseId][this.currentMcqIndex] =
        this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex];
  }

  private firstQuestion() {
    this.switcherCount++;

    this.changeSubject(0);
    this.currentMcqIndex = 0;

    if (this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex])
      this.selected[this.selectedWorkItem.courseId][this.currentMcqIndex] =
        this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex];
  }

  get getTotalSeries() {
    let series: any = [];
    let total = 0;
    for (let i = 0; i < this.testSubjectsData.length; i++) {
      series.push(this.subjectCorrect[this.testSubjectsData[i].courseId]);
      total += this.subjectCorrect[this.testSubjectsData[i].courseId];
    }

    series.push(this.totalQuestions - total);
    return series;
  }

  get getStart() {
    if (!this.startTimeX) {
      this.startTimeX = moment();
      return this.startTimeX;
    } else {
      return this.startTimeX;
    }
  }

  get getEnd() {
    if (!this.endTimeX) {
      this.endTimeX = this.isSelfAwareness
        ? moment(JSON.parse(this.selectedWorkItemAwareness.Dated).toDate)
        : moment().add(this.actualDuration, "minutes");
      return this.endTimeX;
    } else {
      return this.endTimeX;
    }
  }

  // private async getTime() {
  //   return await this.service.getTime().then((response) => {
  //     return moment(response);
  //   });
  // }

  private testResultScreen() {
    this.showResult = true;
    this.showTestResults = false;
  }

  private finishTestModal() {
    this.finish = true;
    this.$bvModal.show("confirm-end");
  }

  private resetTestModal() {
    this.finish = false;
    this.$bvModal.show("confirm-end");
  }

  private handleCancel() {
    this.firstTimeReset = false;
  }

  private finishTest() {
    window.scrollTo(0, 0);
    this.endTime = moment();
    this.testAttemptedOnce = true;

    clearInterval(this.interval);

    if (this.endTime.diff(this.startTime, "hours") !== 0) {
      this.timeElapsed =
        this.endTime.diff(this.startTime, "hours", true).toFixed(2) + " Hours";
    } else if (this.endTime.diff(this.startTime, "minutes") !== 0) {
      this.timeElapsed =
        this.endTime.diff(this.startTime, "minutes", true).toFixed(2) +
        " Minutes";
    } else {
      this.timeElapsed =
        this.endTime.diff(this.startTime, "seconds") + " Seconds";
    }
    let selectedWork =
      localStorage[config.selectedWork] !== undefined
        ? JSON.parse(localStorage[config.selectedWork])
        : null;

    let result: any = [];
    let series: any = [];
    let total = 0;

    let totalScore = 0;
    // if (!this.isSelfAwareness){
    //   for (let i = 0; i < this.testSubjectsData.length; i++) {
    //     let temp = {
    //       Subject: this.testSubjectsData[i].courseId,
    //       Om: this.subjectCorrect[this.testSubjectsData[i].courseId],
    //       Im: this.subjectIncorrect[this.testSubjectsData[i].courseId],
    //       Tm: this.totalSubjects[this.testSubjectsData[i].courseId],
    //     };
    //     if (!this.isM)
    //       totalScore +=
    //         this.subjectCorrect[this.testSubjectsData[i].courseId] * 4 -
    //         this.subjectIncorrect[this.testSubjectsData[i].courseId];
    //     else totalScore += this.subjectCorrect[this.testSubjectsData[i].courseId];

    //     series.push(this.subjectCorrect[this.testSubjectsData[i].courseId]);
    //     total += this.subjectCorrect[this.testSubjectsData[i].courseId];

    //     result.push(temp);
    //   }

    //   series.push(this.totalIncorrect);
    //   series.push(this.totalQuestions - total - this.totalIncorrect);
    // }
    // if (
    //   !this.isSelfAwareness &&
    //     !this.loadingTestFirst)
    //  {
    //   this.service
    //     .setResult(
    //       this.sheetId,
    //       Math.max(totalScore, 0),
    //       this.isM ? this.totalQuestions : this.totalQuestions * 4,
    //       this.isSelfAwareness
    //         ? JSON.stringify(this.savedAnswers)
    //         : JSON.stringify(result),
    //       selectedWork
    //     )
    //     .then((response) => {
    //       this.totalSeries++;
    //       this.totalSeriesData = series;
    //       this.showResult = true;
    //     });
    // } else if (this.isSelfAwareness) {
    this.service.getResultExam(selectedWork, this.sheetId).then((response) => {
      this.totalIncorrect = 0;
      this.totalCorrect = 0;
      this.totalQuestions = 0;
      this.totalNotAttempted = 0;
      for (let i = 0; i < response.length; i++) {
        this.subjectIncorrect[response[i].courseName] = response[i].inCorrect;
        this.subjectCorrect[response[i].courseName] = response[i].correct;
        this.totalCorrect += response[i].correct;
        this.totalIncorrect += response[i].inCorrect;
        this.totalNotAttempted += response[i].notAttempted;
        let temp = {
          Subject: response[i].courseName,
          Om: response[i].correct,
          Im: response[i].inCorrect,
          Tm:
            response[i].correct +
            response[i].inCorrect +
            response[i].notAttempted,
        };
        if (!this.isM)
          totalScore += response[i].correct * 4 - response[i].inCorrect;
        else totalScore += response[i].correct;

        series.push(response[i].correct);
        total += response[i].correct;

        result.push(temp);
      }

      this.totalQuestions =
        this.totalCorrect + this.totalIncorrect + this.totalNotAttempted;
      series.push(this.totalIncorrect);
      series.push(this.totalQuestions - total - this.totalIncorrect);
      this.totalSeriesData = series;
      this.totalSeries++;
      this.showResult = true;
    });
    // }

    // else {
    //   this.totalSeries++;
    //   this.totalSeriesData = series;
    //   this.showResult = true;
    // }
  }

  private startSaving() {
    let selectedWork =
      localStorage[config.selectedWork] !== "undefined"
        ? JSON.parse(localStorage[config.selectedWork])
        : null;

    let result: any = [];
    let total = 0;

    let totalScore = 0;

    for (let i = 0; i < this.testSubjectsData.length; i++) {
      let temp = {
        Subject: this.testSubjectsData[i].courseId,
        Om: this.subjectCorrect[this.testSubjectsData[i].courseId],
        Im: this.subjectIncorrect[this.testSubjectsData[i].courseId],
        Tm: this.totalSubjects[this.testSubjectsData[i].courseId],
      };
      if (!this.isM)
        totalScore +=
          this.subjectCorrect[this.testSubjectsData[i].courseId] * 4 -
          this.subjectIncorrect[this.testSubjectsData[i].courseId];
      else totalScore += this.subjectCorrect[this.testSubjectsData[i].courseId];

      total += this.subjectCorrect[this.testSubjectsData[i].courseId];

      result.push(temp);
    }

    // this.service
    //   .setResult(
    //     this.sheetId,
    //     Math.max(totalScore, 0),
    //     this.isM ? this.totalQuestions : this.totalQuestions * 4,
    //     this.isSelfAwareness
    //       ? JSON.stringify(this.savedAnswers)
    //       : JSON.stringify(result),
    //     selectedWork
    //   )
    //   .then((response) => {
    //     console.log("Autosave at " + moment());
    //   });
  }

  private answerAnsSelected = [];

  private changeSubject(index) {
    this.switcherCount++;
    this.minQuestion = 0;
    this.currentSubjectTest = index;
    this.currentMcqIndex = 0;
    this.selectedWorkItem = this.testSubjectsData[this.currentSubjectTest];
    this.disable = this.disableTests[this.selectedWorkItem.courseId];
    if (this.answerAnsTests[this.selectedWorkItem.courseId])
      this.answerAnsSelected =
        this.answerAnsTests[this.selectedWorkItem.courseId];
    else {
      this.answerAnsTests[this.selectedWorkItem.courseId] = [];
      this.answerAnsSelected =
        this.answerAnsTests[this.selectedWorkItem.courseId];
    }

    if (this.displayTests[this.selectedWorkItem.courseId])
      this.displaySelected = this.displayTests[this.selectedWorkItem.courseId];
    else {
      this.displayTests[this.selectedWorkItem.courseId] = [];
      this.displaySelected = this.displayTests[this.selectedWorkItem.courseId];
    }

    if (this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex])
      this.selected[this.selectedWorkItem.courseId][this.currentMcqIndex] =
        this.savedValues[this.selectedWorkItem.courseId][this.currentMcqIndex];
    window.scrollTo(0, 0);
  }

  private viewResults() {
    let selectedWork =
      localStorage[config.selectedWork] !== undefined
        ? JSON.parse(localStorage[config.selectedWork])
        : null;
    window.open(
      "/test-result?workDayId=" +
        selectedWork +
        "&title=" +
        this.selectedWorkObject.Title,
      "_blank"
    );
  }

  private retakeTest() {
    let selectedWork =
      localStorage[config.selectedWork] !== undefined
        ? JSON.parse(localStorage[config.selectedWork])
        : null;
    this.service
      .resetTest(selectedWork, this.selectedWorkObject.Title)
      .then((response) => {
        window.location.reload();
      });
  }

  private goToQuestionEx(question) {
    this.changeSubject(question.sectionId);
    this.currentMcqIndex = question.idx;
    let qs = this.allQuestions.filter((element) => !element.attempted);

    for (let i = 0; i < qs.length; i++) {
      if (qs[i].mcqs.questionText == question.mcqs.questionText) {
        this.minQuestion = i;
      }
    }
  }

  private goToQuestion(item) {
    this.changeSubject(item.sectionIndex);
    this.currentMcqIndex = item.questionIndex;
    for (let i = 0; i < this.allQuestions.length; i++) {
      if (
        this.allQuestions[i].mcqs.questionText ==
        item.questionObject.questionText
      ) {
        this.minQuestion = this.allQuestions[i].indx;
      }
    }
  }

  private goToBlog(link) {
    window.open(link, '_blank');
  }

  private interval: any;

  private orderMcqs(data) {
    let orderedMcqs: any = [];
    if (data && data.length > 1) {
      for (let i = 0; i < data.length; i++) {
        orderedMcqs[data[i].orderNo - 1] = data[i];
      }

      return orderedMcqs;
    }

    return data;
  }

  private randomizeMcqs(data) {
    if (data) {
      for (let k = 0; k < data.length; k++) {
        let array = data[k].mcqs;
        for (let i = array.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var temp = array[i];
          array[i] = array[j];
          array[j] = temp;
        }
      }
    }

    return data;
  }

  private async showDetails(item, index) {
    window.scrollTo(0, 0);
    this.firstTimeReset = true;
    this.selectedWorkObject = item;
    this.selectedWorkItem = item;
    this.selectedType = item.Type;
    this.selectedName = item.Title;

    if (item.Type == "SelfAwareness") {
      this.selectedWorkItemAwareness = item;
      if (item.DisplayResult == 1) {
        this.displayResult = true;
      }

      if (
        !moment().isBetween(
          moment(JSON.parse(item.Dated).fromDate),
          moment(JSON.parse(item.Dated).toDate)
        ) &&
        this.displayResult == false
      )
        return;
    }
    this.currentWorkItem = index;
    this.testSubjectsData = [];
    this.currentSubjectTest = 0;
    this.sheetId = item.Title;
    if (item.Type == "WorkSheet" || item.Type == "Drills") {
      await this.service.getWorkSheet(item.Id).then((response) => {
        this.resetMcqs();
        this.selectedWorkItem = response[0];
        this.selected[this.selectedWorkItem.courseId] = [];
        this.savedValues[this.selectedWorkItem.courseId] = [];
        this.selectedWorkItem.mcqs = JSON.parse(this.selectedWorkItem.mcqs);
        this.setCorrect();
        this.view = 1;
      });
      // } else if (item.Type == "Test") {
      //   this.startTimeTimer = moment();
      //   this.endTimeTimer = this.isSelfAwareness
      //     ? moment(JSON.parse(this.selectedWorkItemAwareness.Dated).toDate)
      //     : moment().add(this.selectedWorkItem.duration, "minutes");
      //   this.startTimer = true;
      //   this.testTimer++;
      //   let selectedWork =
      //     localStorage[config.selectedWork] !== "undefined"
      //       ? JSON.parse(localStorage[config.selectedWork])
      //       : null;
      //   await this.service
      //     .getTest(item.Title, selectedWork, false)
      //     .then((response) => {
      //       this.testSubjectsData = response;
      //       let questionInd = 0;
      //       for (let i = 0; i < this.testSubjectsData.length; i++) {
      //         this.testSubjectsData[i].keyFile = "Test";
      //         let parsedMcq = JSON.parse(this.testSubjectsData[i].mcqs);
      //         for (let j = 0; j < parsedMcq.length; j++) {
      //           this.allQuestions.push({
      //             courseId: this.testSubjectsData[i].courseId,
      //             mcqs: parsedMcq[j],
      //             idx: j,
      //             sectionId: i,
      //             attempted: false,
      //             indx: questionInd,
      //           });
      //           questionInd++;
      //         }
      //       }

      //       this.totalQuestions = 0;

      //       this.service.getResult(item.Title, selectedWork).then((response) => {
      //         if (response.length > 0 && item.Type == "Test") {
      //           this.totalQuestions = 0;
      //           this.totalCorrect = 0;
      //           let resultData = JSON.parse(response[0].result);

      //           let totalIn = 0;
      //           for (let i = 0; i < resultData.length; i++) {
      //             this.subjectCorrect[resultData[i].Subject] = resultData[i].Om;
      //             this.totalSubjects[resultData[i].Subject] = resultData[i].Tm;
      //             this.subjectIncorrect[resultData[i].Subject] = resultData[i].Im;
      //             totalIn += resultData[i].Im;
      //             this.totalQuestions += resultData[i].Tm;
      //             this.totalCorrect += resultData[i].Om;
      //           }
      //           let series: any = [];
      //           let total = 0;
      //           for (let i = 0; i < this.testSubjectsData.length; i++) {
      //             series.push(
      //               this.subjectCorrect[this.testSubjectsData[i].courseId]
      //             );
      //             total += this.subjectCorrect[this.testSubjectsData[i].courseId];
      //           }

      //           this.totalIncorrect = totalIn;

      //           series.push(this.totalIncorrect);
      //           series.push(this.totalQuestions - total - this.totalIncorrect);
      //           this.totalSeriesData = series;
      //           this.showResult = true;
      //         }
      //       });
      //       let mcqIndex = 1;
      //       for (let i = 0; i < this.testSubjectsData.length; i++) {
      //         this.testSubjectsData[i].mcqs = JSON.parse(
      //           this.testSubjectsData[i].mcqs
      //         );

      //         for (let j = 0; j < this.testSubjectsData[i].mcqs.length; j++) {
      //           this.testSubjectsData[i].mcqs[j].indx = mcqIndex;
      //           mcqIndex++;
      //         }
      //         this.totalSubjects[this.testSubjectsData[i].courseId] =
      //           this.testSubjectsData[i].mcqs.length;
      //         this.totalQuestions += this.testSubjectsData[i].mcqs.length;
      //         this.selected[this.testSubjectsData[i].courseId] = [];
      //         this.savedValues[this.testSubjectsData[i].courseId] = [];
      //         this.disableTests[this.testSubjectsData[i].courseId] = [];
      //         this.answerAnsTests[this.testSubjectsData[i].courseId] = [];
      //         this.subjectCorrect[this.testSubjectsData[i].courseId] = 0;
      //         this.subjectIncorrect[this.testSubjectsData[i].courseId] = 0;
      //       }
      //       this.selectedWorkItem = this.testSubjectsData[this.currentSubjectTest];
      //       console.log(this.selectedWorkItem.mcqs);

      //       this.answerAnsTests[this.selectedWorkItem.courseId] = [];
      //       this.answerAnsSelected =
      //         this.answerAnsTests[this.selectedWorkItem.courseId];
      //       this.displayTests[this.selectedWorkItem.courseId] = [];
      //       this.displaySelected =
      //         this.displayTests[this.selectedWorkItem.courseId];
      //       if (item.Type == "SelfAwareness") {
      //         this.selectedWorkItem.keyFile = "Test";
      //         this.isSelfAwareness = true;
      //       }
      //       this.view = 1;
      //       this.startTime = moment();
      //     });
    } else if (item.Type == "SelfAwareness" || item.Type == "Test" || item.Type == "Quiz") {
      if (item.Type == "SelfAwareness") this.isSelfAwareness = true;
      this.startTimeTimer = moment();
      this.endTimeTimer = this.isSelfAwareness
        ? moment(JSON.parse(this.selectedWorkItemAwareness.Dated).toDate)
        : moment().add(this.selectedWorkItem.duration, "minutes");
      this.startTimer = true;
      this.testTimer++;
      let selectedWork =
        localStorage[config.selectedWork] !== undefined
          ? JSON.parse(localStorage[config.selectedWork])
          : null;

      // if (!this.isSelfAwareness) {
      //   await this.service
      //   .getTestStep(item.Title, selectedWork, false)
      //   .then((response) => {
      //     this.actualDuration = response[0].duration;
      //     this.testTimer++;
      //   })
      // }

      if (!this.displayResult) {
        this.allQuestions = []
        await this.service
          .getQuestionsExam(selectedWork, item.Title)
          .then((response) => {
            this.testSubjectsData = this.isSelfAwareness
              ? this.randomizeMcqs(response)
              : this.orderMcqs(response);
            if (this.checkAttempted(this.testSubjectsData)) {
              this.$bvModal.show("confirm-end");
            }
            let questionInd = 0;
            for (let i = 0; i < this.testSubjectsData.length; i++) {
              this.testSubjectsData[i].keyFile = "Test";
              this.testSubjectsData[i].courseId =
                this.testSubjectsData[i].courseName;
              let parsedMcq = this.testSubjectsData[i].mcqs;
              for (let j = 0; j < parsedMcq.length; j++) {
                this.testSubjectsData[i].mcqs[j].questionText =
                  this.testSubjectsData[i].mcqs[j].questionTxt;
                this.allQuestions.push({
                  courseId: this.testSubjectsData[i].courseId,
                  mcqs: parsedMcq[j],
                  idx: j,
                  sectionId: i,
                  attempted: false,
                  indx: questionInd,
                });
                questionInd++;
              }
            }

            this.totalQuestions = 0;
            let mcqIndex = 1;
            for (let i = 0; i < this.testSubjectsData.length; i++) {
              this.totalSubjects[this.testSubjectsData[i].courseId] =
                this.testSubjectsData[i].mcqs.length;
              this.totalQuestions += this.testSubjectsData[i].mcqs.length;
              this.selected[this.testSubjectsData[i].courseId] = [];
              this.savedValues[this.testSubjectsData[i].courseId] = [];
              this.disableTests[this.testSubjectsData[i].courseId] = [];
              this.answerAnsTests[this.testSubjectsData[i].courseId] = [];
              this.subjectCorrect[this.testSubjectsData[i].courseId] = 0;
              this.subjectIncorrect[this.testSubjectsData[i].courseId] = 0;
              for (let j = 0; j < this.testSubjectsData[i].mcqs.length; j++) {
                this.testSubjectsData[i].mcqs[j].indx = mcqIndex;
                mcqIndex++;
              }
            }
            this.attempted = 0;

            this.selectedWorkItem =
              this.testSubjectsData[this.currentSubjectTest];
            this.populateExam(this.testSubjectsData);

            this.answerAnsTests[this.selectedWorkItem.courseId] = [];
            this.answerAnsSelected =
              this.answerAnsTests[this.selectedWorkItem.courseId];
            this.displayTests[this.selectedWorkItem.courseId] = [];
            this.displaySelected =
              this.displayTests[this.selectedWorkItem.courseId];
            if (item.Type == "SelfAwareness") {
              this.selectedWorkItem.keyFile = "Test";
              this.isSelfAwareness = true;
            }
            this.view = 1;
            this.startTime = moment();
          });
      }

      if (this.displayResult) {
        let series: any = [];
        let result: any = [];
        let totalScore = 0;
        let total = 0;

        this.service
          .getResultExam(selectedWork, this.sheetId)
          .then((response) => {
            this.totalIncorrect = 0;
            this.totalCorrect = 0;
            this.totalQuestions = 0;
            this.totalNotAttempted = 0;
            for (let i = 0; i < response.length; i++) {
              this.testSubjectsData.push({ courseId: response[i].courseName });
              this.subjectIncorrect[response[i].courseName] =
                response[i].inCorrect;
              this.subjectCorrect[response[i].courseName] = response[i].correct;
              this.totalSubjects[response[i].courseName] =
                response[i].correct +
                response[i].inCorrect +
                response[i].notAttempted;
              this.totalCorrect += response[i].correct;
              this.totalIncorrect += response[i].inCorrect;
              this.totalNotAttempted += response[i].notAttempted;
              let temp = {
                Subject: response[i].courseName,
                Om: response[i].correct,
                Im: response[i].inCorrect,
                Tm:
                  response[i].correct +
                  response[i].inCorrect +
                  response[i].notAttempted,
              };
              if (!this.isM)
                totalScore += response[i].correct * 4 - response[i].inCorrect;
              else totalScore += response[i].correct;

              series.push(response[i].correct);
              total += response[i].correct;

              result.push(temp);
            }

            this.totalQuestions =
              this.totalCorrect + this.totalIncorrect + this.totalNotAttempted;
            series.push(this.totalIncorrect);
            series.push(this.totalQuestions - total - this.totalIncorrect);
            this.totalSeriesData = series;
            this.totalSeries++;
            this.showResult = true;
            this.view = 1;
          });
      }
    }
    this.view = 1;
    if (this.selectedWorkItem.VideoLink) {
      this.source = this.selectedWorkItem.VideoLink;
    }
  }

  private populateExam(response) {
    for (let i = 0; i < response.length; i++) {
      for (let j = 0; j < response[i].answerInput?.length; j++) {
        for (let k = 0; k < response[i].mcqs?.length; k++) {
          if (
            response[i].answerInput[j].question ===
            response[i].mcqs[k].questionTxt
          ) {
            if (!response[i].answerInput[j].isReview) {
              this.savedValues[response[i].courseName][k] =
                response[i].answerInput[j].answerValue;
              this.selected[response[i].courseName][k] =
                response[i].answerInput[j].answerValue;
              this.removeAnswer(response[i].mcqs[k]);
              this.saveAnswer(
                response[i].answerInput[j].answerValue,
                k,
                response[i].courseName,
                response[i].mcqs[k].questionTxt,
                i
              );

              for (let m = 0; m < this.allQuestions.length; m++) {
                if (
                  this.allQuestions[m].mcqs.questionText ===
                  response[i].mcqs[k].questionTxt
                ) {
                  this.allQuestions[m].attempted = true;
                }
              }

              this.attempted++;

              Vue.set(this.disable, k, true);
            } else {
              this.selected[response[i].courseName][k] =
                response[i].answerInput[j].answerValue;
              this.reviewQuestions.push({
                answer: response[i].answerInput[j].answerValue,
                questionIndex: k,
                sectionName: response[i].courseName,
                questionObject: response[i].mcqs[k],
                sectionIndex: i,
              });
            }
          }
        }
      }
    }
  }

  checkAttempted(data: any) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].answerInput !== null) {
        return true;
      }
    }

    return false;
  }

  setCorrect() {
    this.correct = [];
    for (let i = 0; i < this.selectedWorkItem.mcqs.length; i++) {
      this.correct[i] = this.selectedWorkItem.mcqs[i].answers[0];
    }
  }

  private nextWork() {
    if (this.currentWorkItem < this.tableItemsSorted.length - 1) {
      this.currentWorkItem++;
      this.showDetails(
        this.tableItemsSorted[this.currentWorkItem],
        this.currentWorkItem
      );
    }
  }

  private renderHTML(x) {
    return config.renderHTML(x);
  }

  private previousWork() {
    if (this.currentWorkItem !== 0) {
      this.currentWorkItem--;
      this.showDetails(
        this.tableItemsSorted[this.currentWorkItem],
        this.currentWorkItem
      );
    }
  }

  private openHelp() {
    this.$bvModal.show("how-to");
  }

  private joinTeam() {
    window.open("https://teams.microsoft.com/", "_blank");
  }

  private goBack() {
    this.sourceLoaded = false;
    this.errorDisable = true;
    this.view = 0;
  }

  private rowClass(item, type) {
    if (!item || type !== "row") return;

    return "cursor-pointer";
  }

  private fields = [
    { key: "Type" },
    { key: "CourseId", label: "Subject" },
    { key: "Title" },
  ];

  private reviewFields = [
    {
      key: "questionObject",
      label: "Question No.",
      formatter: (value) => {
        return value.indx;
      },
    },
    { key: "sectionName", label: "Section" },

    { key: "answer", label: "Answer Selected" },
  ];

  private sheetfields = [
    { key: "Type" },
    { key: "CourseId", label: "Subject" },
    { key: "Title" },
  ];

  private testfields = [
    { key: "Type" },
    { key: "Title" },
  ];

  private testfields2 = [
    { key: "Title" },
    {
      key: "Dated",
      label: "Status",
      tdClass: "checkReady",
      formatter: (value) => {
        let parsed = JSON.parse(value);
        if (
          moment().isBetween(moment(parsed.fromDate), moment(parsed.toDate))
        ) {
          return "Started";
        } else if (moment() < moment(parsed.fromDate)) {
          return (
            "Starting at " + moment(parsed.fromDate).format("DD-MM-YYYY h:m a")
          );
        } else {
          return "Ended at " + moment(parsed.toDate).format("DD-MM-YYYY h:m a");
        }
      },
    },
    {
      key: "DisplayResult",
      label: "Results",
      tdClass: "checkReady",
      formatter: (value) => {
        if (value == 1) {
          return "Ready";
        } else {
          return "Not Ready";
        }
      },
    },
  ];

  private displayTests: any = [];
  private answerAnsTests: any = [];

  private checkReady(value) {
    if (value == 1) {
      return "text-green";
    } else {
      return "text-red";
    }
  }

  private checkStatus(value) {
    let parsed = JSON.parse(value);
    if (moment().isBetween(moment(parsed.fromDate), moment(parsed.toDate))) {
      return "text-green";
    } else if (moment() < moment(parsed.fromDate)) {
      return "text-red";
    } else {
      return "text-red";
    }
  }

  reviewAnswer(answer, questionIndex, section, question, sectionIndex) {
    let index = this.reviewQuestions.findIndex((e) => {
      return e.questionObject.indx == question.indx;
    });

    if (index !== -1) {
      this.reviewQuestions.splice(index, 1);
    }

    this.service
      .updateAnswerExam(
        this.selectedWorkItem.workSheetId,
        question.questionText,
        answer,
        true
      )
      .then(() => {
        this.reviewQuestions.push({
          answer: answer,
          questionIndex: questionIndex,
          sectionName: section,
          questionObject: question,
          sectionIndex: sectionIndex,
        });
      });
  }

  saveAnswer(answer, questionIndex, section, question, sectionIndex) {
    let check = false;

    let index = this.savedAnswers.findIndex((e) => {
      return e.questionObject.questionText == question.questionText;
    });

    if (index !== -1) {
      this.savedAnswers.splice(index, 1);
      check = true;
    }

    this.savedAnswers.push({
      answer: answer,
      questionIndex: questionIndex,
      sectionName: section,
      questionObject: question,
      sectionIndex: sectionIndex,
    });
    return check;
  }

  removeAnswer(question) {
    let index = this.reviewQuestions.findIndex((e) => {
      return e.questionObject.questionText == question.questionText;
    });

    if (index !== -1) {
      this.reviewQuestions.splice(index, 1);
    }
  }

  async populateAnswer(
    answer,
    questionIndex,
    sectionName,
    question,
    sectionIndex
  ) {
    for (let i = 0; i < this.testSubjectsData[sectionIndex].mcqs.length; i++) {
      if (
        this.testSubjectsData[sectionIndex].mcqs[i].questionText ==
        question.questionText
      ) {
        this.savedValues[sectionName][i] = answer;
        this.selected[sectionName][i] = answer;
        this.saveAnswer(
          answer,
          questionIndex,
          sectionName,
          question,
          sectionIndex
        );
        this.answerAnsTests[sectionName][i] =
          answer == JSON.parse(question.answers)[0].correctAnswer
            ? "alert-success"
            : "alert-danger";
        if (JSON.parse(question.answers)[0].correctAnswer == answer) {
          this.subjectCorrect[sectionName]++;
          this.totalCorrect++;
          Vue.set(this.answerAns, i, "alert-success");
        } else {
          this.subjectIncorrect[sectionName]++;
          this.totalIncorrect++;
          Vue.set(this.answerAns, i, "alert-danger");
        }
        this.attempted++;

        Vue.set(this.disable, i, true);
      }
    }
    let series: any = [];
    let total = 0;

    let totalScore = 0;

    for (let i = 0; i < this.testSubjectsData.length; i++) {
      series.push(this.subjectCorrect[this.testSubjectsData[i].courseId]);
    }

    series.push(this.totalIncorrect);
    series.push(this.totalQuestions - total - this.totalIncorrect);

    this.totalSeries++;
    this.totalSeriesData = series;
    this.worksheetKey++;
  }

  checkAnswer(answer, i, item, question, sectionIndex) {
    if (!answer) return;
    this.display[i] = true;
    if (item) {
      this.service
        .updateAnswerExam(
          this.selectedWorkItem.workSheetId,
          question.questionText,
          answer,
          false
        )
        .then((response) => {
          this.removeAnswer(this.selectedWorkItem.mcqs[this.currentMcqIndex]);
          this.saveAnswer(answer, i, item, question, sectionIndex);
          for (let i = 0; i < this.allQuestions.length; i++) {
            if (
              this.allQuestions[i].mcqs.questionText == question.questionText
            ) {
              this.allQuestions[i].attempted = true;
            }
          }
        });
    }

    if (!this.isSelfAwareness && !item) {
      if (this.correct[i].correctAnswer == answer) {
        Vue.set(this.answerAns, i, "alert-success");
      } else {
        Vue.set(this.answerAns, i, "alert-danger");
      }
    }

    // if (!this.disable[i])
    this.attempted++;

    Vue.set(this.disable, i, true);

    if (item !== false) {
      this.disableTests[item][i] = true;
      this.displayTests[item][i] = true;
      this.savedValues[item][i] = answer;
    }
  }

  private worksheetKey = 0;

  private resetMcqs() {
    this.attempted = 0;
    this.display = [];
    this.disable = [];
    this.savedAnswers = [];
    this.answerAns = [];
    this.selected[this.selectedWorkItem.courseId] = [];
    this.savedValues[this.selectedWorkItem.courseId] = [];
    this.worksheetKey++;
  }

  sortArray(array) {
    return array.sort(function (a, b) {
      let nameA = a.CourseId.toLowerCase(),
        nameB = b.CourseId.toLowerCase();
      if (nameA < nameB)
        //sort string ascending
        return -1;
      if (nameA > nameB) return 1;
      return 0; //default return value (no sorting)
    });
  }

  private checkBrowser(src, calback) {
    let brow = "widevine";
    if (isIE || isEdge) {
      brow = "playReady";
    } else if (isIOS) {
      brow = "clear";
    }
    this.getToken(src, brow, (data) => {
      calback(data);
    });
  }
  private getToken(source, brow, callback) {
    this.service
      .getVideoToken(source, brow)
      .then((result) => {
        this.srcToken = result;
        callback(result);
        // this.player.src([
        //   {
        //     src: result.src, //response.src,
        //     type: "application/vnd.ms-sstr+xml", //response.type,
        //     protectionInfo: [
        //       {
        //         type: result.protectionInfo.type,
        //         certificateUrl: result.protectionInfo.certificateUrl,
        //         authenticationToken: result.protectionInfo.authenticationToken,
        //       },
        //     ],
        //   },
        // ]);
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  private changedAnswer(answer) {
    if (this.isM) {
      this.checkAnswer(
        answer,
        this.currentMcqIndex,
        this.selectedWorkItem.courseId,
        this.selectedWorkItem.mcqs[this.currentMcqIndex],
        this.currentSubjectTest
      );
    }
  }

  private loadVideo(encrypt: Boolean) {
    let client = document.getElementById("main-content");
    if (client !== null) {
      this.player = amp("azuremediaplayer", {
        nativeControlsForTouch: false,
        logo: { enabled: false },
        autoplay: true,
        controls: true,
        fluid: true,
        playbackSpeed: {
          enabled: true,
          initialSpeed: 1.0,
          speedLevels: [
            { name: "x4.0", value: 4.0 },
            { name: "x3.0", value: 3.0 },
            { name: "x2.0", value: 2.0 },
            { name: "x1.75", value: 1.75 },
            { name: "x1.5", value: 1.5 },
            { name: "x1.25", value: 1.25 },
            { name: "normal", value: 1.0 },
            { name: "x0.75", value: 0.75 },
            { name: "x0.5", value: 0.5 },
          ],
        },
        width: "auto",
        height: 600,
        techOrder: [
          "azureHtml5JS",
          "flashSS",
          "html5FairPlayHLS",
          "silverlightSS",
          "html5",
        ],
      });
    } else {
    }
    if (encrypt) {
      this.player.src([
        {
          src: this.srcToken.src, //response.src,
          type: this.srcToken.Type, //response.type,
          protectionInfo: [
            {
              type: this.srcToken.protectionInfo.type,
              certificateUrl: this.srcToken.protectionInfo.certificateUrl,
              authenticationToken:
                this.srcToken.protectionInfo.authenticationToken,
            },
          ],
        },
      ]);
    } else {
      this.player.src([
        { type: "application/vnd.ms-sstr+xml", src: this.source },
      ]);
    }

    this.player.addEventListener("error", this.errorPlayback);

    this.sourceLoaded = true;
  }

  errorPlayback() {
    this.errorMessage =
      "There was an issue in your playback, kindly check your internet connection. We will reload the video so you can seamlessly view it again.";

    this.lastTime = this.player.currentTime();
    this.startError = true;

    this.player.src([
      { type: "application/vnd.ms-sstr+xml", src: this.source },
    ]);
  }

  private seperate(data, type) {
    if (type == "video") {
      this.lectures = [];
      this.discussions = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].Type == "Lecture") {
          this.lectures.push(data[i]);
        } else {
          this.discussions.push(data[i]);
        }
      }
    } else if (type == "test") {
      this.tests = [];
      this.worksheets = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].Type == "WorkSheet") {
          this.worksheets.push(data[i]);
        } else {
          this.tests.push(data[i]);
        }
      }
    }
  }

  private loadData(program) {
    this.service
      .getWorkDayId(program.id, 1)
      .then((work) => {
        let selectedWork = work[0]?.workDayId;
        localStorage[config.selectedWork] = JSON.stringify(selectedWork);
        this.discussions = []
        this.lectures = []
        this.worksheets = []
        this.drills = []
        this.blogs = []
        this.expertTips = []
        this.selfTests = []

        this.service.getDayWorkEx(selectedWork).then((response) => {
          this.selectProgram = program.name;
          localStorage[config.selectedStepProgram] = JSON.stringify(program);
          if (response[0].discussion)
            this.discussions = JSON.parse(response[0].discussion)
          if (response[0].lecture)
            this.lectures = JSON.parse(response[0].lecture)
          if (response[0].workSheet)
            this.worksheets = JSON.parse(response[0].workSheet);
          if (response[0].drills)
            this.drills = JSON.parse(response[0].drills);
          if (response[0].articleWebsiteLinksWithTitles){
            this.blogs = JSON.parse(response[0].articleWebsiteLinksWithTitles)
          }
          if (response[0].test) this.tests = JSON.parse(response[0].test);
          if (response[0].videosWithTitles){
            this.expertTips = JSON.parse(response[0].videosWithTitles);
          }
          if (response[0].quiz) this.quizzes = JSON.parse(response[0].quiz);
          if (response[0])
          if (response[0].selfAwareness)
            this.selfTests = JSON.parse(response[0].selfAwareness);
          for (let i = 0; i < this.tests.length; i++) {
            if (this.tests[i].Score !== null) {
              this.testAttempted = true;
            }
          }
        });
      });
  }

  mounted() {
    if (!this.auth.session) {
      this.$router.push("/");
    }

    if (localStorage[config.selectedStepProgram] && localStorage[config.selectedStepProgram] !== undefined) {
      this.selectProgram = JSON.parse(localStorage[config.selectedStepProgram]).name
      if (this.selectProgram === 'F.Sc (Medical)') {
        this.isM = true;
      }
      this.loadData(JSON.parse(localStorage[config.selectedStepProgram]))
    }

    window.onpopstate = function () {
      window.location.reload();
    };
  }
}
